import React from 'react';
import SearchResults from '../../searchresults';

export default class HeaderPanelMiddle extends React.Component {
  static propTypes = {
    panels: React.PropTypes.object,
    searchTerm: React.PropTypes.string
  };

  render () {
    if (!this.props.searchTerm) {
      return false;
    }

    return (
      <div className="header__panel--middle">
        <SearchResults {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/panels/middle/index.js